<template>
  <div>
    <b-row>
      <b-col cols="12" class="my-3">
        <Search
          v-if="personLicenseUrl"
          :allowFields="$lang.lineces_fields"
          :allowCollapse="false"
          :url="personLicenseUrl"
          :title="$lang.licenses"
          config="personLicensesSearch"
          :showAlert="true"
          colorAlert="success"
          :titleAlert="$lang.government_permits"
          addModalSize="lg"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :allowEdit="false"
          :toggleable="true"
          :visibleAccordion="true"
          ref="personLicensesSearch"
          :dynamicButtons="personLicenseButtons"
          :parentPermissions="permissions"
          @getPermisson="getPermissions"
          :visibleAdd="isAdmin(permissions, ['admin'])"
        >
          <template slot="addModal" slot-scope="search">
            <AddLicencePerson
              :code="code"
              @close="search.close"
              @getData="getData"
            />
          </template>
        </Search>
        <b-modal
          :title="$lang.search.columns_setting"
          variant="primary"
          size="xl"
          content-class="border-primary"
          v-model="view_edit_person_license"
          :ok-title="$lang.submitButton"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <EditLicencePerson
            :itemId="itemId"
            :code="code"
            @cancel="cancel"
            @getData="getData"
          />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddLicencePerson from "./addLicencePerson.vue";
import EditLicencePerson from "./editLicencePerson.vue";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "search-license-person",
  props: {
    code: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    Search,
    AddLicencePerson,
    EditLicencePerson,
  },
  data() {
    return {
      permissions: [],
      itemId: null,
      person_icense_code: null,
      mode: "",
      view_edit_person_license: false,
      personLicenseButtons: [
        {
          id: 0,
          name: "edit",
          click: this.changeLicense,
        },
        {
          id: "1",
          name: "view",
          click: this.changeLicense,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    personLicenseUrl() {
      return generateApiUrl(["profile", "person_license"], [this.code]);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    getData() {
      this.itemId = null;
      this.cancel();
      this.$refs.personLicensesSearch.getItems();
    },
    getPermissions(permissions) {
      this.permissions = permissions;
      this.$emit("getPermissions", permissions);
    },
    cancel() {
      this.view_edit_person_license = false;
    },
    modalAddPersonLicense() {
      this.view_edit_person_license = true;
      this.itemId = null;
    },
    changeLicense(item) {
      this.itemId = pathOr(null, ["id"], item);
      this.view_edit_person_license = true;
    },
  },
};
</script>
